import { sendWebVital } from "./analytics/gtag";

function handleMetric(metric) {
  if (process.env.NODE_ENV === "development") {
    console.info("[Web Vitals]", metric.name, metric.value, metric.rating);
  }
  sendWebVital(metric);
}

const reportWebVitals = () => {
  import("web-vitals").then(
    ({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(handleMetric);
      getFID(handleMetric);
      getFCP(handleMetric);
      getLCP(handleMetric);
      getTTFB(handleMetric);
    },
  );
};

export default reportWebVitals;
